export default __webpack_public_path__ + "static/media/Bracers of the Sundered Skies.945c1c8c.jpg";